import { useState } from 'preact/hooks';
import { getBrandInfo } from '../helpers/brands';
import { isMobileScreen } from '../helpers/session-Info';

const brandInfo = getBrandInfo();
export default function SetmoreHeader() {
  const [isMobile] = useState(isMobileScreen());

  return (
    <div className="fx fx-v">
      <a
        className="phone-hide btn btn-link text-sm mr-4 tc-primary"
        href={`tel:${brandInfo.supportNumber}`}
      >
        {brandInfo.formattedSupportNumber}
      </a>
      <a
        href={brandInfo.dashboardUrl}
        className={`btn ${
          isMobile ? 'btn-link text-sm' : 'btn-login'
        } tc-primary`}
      >
        Login
      </a>
    </div>
  );
}
